"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactPapaparse = require("react-papaparse");

var DOMPurify = _interopRequireWildcard(require("dompurify"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

// The 3.x version of react-papaparse exposes to XSS. The vulnerable code is
// in the displayFileInfo() method, which displays the file name. 
// It uses this way: this.fileNameInfoRef.current.innerHTML = file.name;
// https://github.com/Bunlong/react-papaparse/blob/v3.14.0/src/CSVReader.tsx
var CsvReader = /*#__PURE__*/function (_CSVReader) {
  _inheritsLoose(CsvReader, _CSVReader);

  function CsvReader(props) {
    return _CSVReader.call(this, props) || this;
  }

  var _proto = CsvReader.prototype;

  _proto.displayFileInfo = function displayFileInfo(file) {
    file.name = DOMPurify.sanitize(file.name);

    _CSVReader.prototype.displayFileInfo.call(this, file);
  };

  return CsvReader;
}(_reactPapaparse.CSVReader);

exports["default"] = CsvReader;